import {ChangeDetectorRef, Component, Input, OnInit} from '@angular/core';
import {FavoriteLink} from './favorite-link/favorite-link.model';
import {SemRestRequestService} from '../../../../../projects/api/src/sem-rest-request/sem-rest-request.service';
import {ApiList} from '../../../API/api-list.enum';
import {Router} from '@angular/router';
import {IsAuthorizedService} from '../../services/is-authorized.service';
import {FavoritesApiService} from '../../../../../projects/api/src/favorite/favorites-api.service';
import {FavoriteType} from '../../../../../projects/api/src/favorite/favorite.model';
import {InsparkMessageService} from '@inspark/inspark-components';
import {TranslateService} from '@ngx-translate/core';

/**
 * Компонент для отображения пункта меню и диалогового окна с избранными ссылками
 */
@Component({
    selector: 'app-favorite-links',
    templateUrl: './favorite-links.component.html',
    styleUrls: ['./favorite-links.component.scss'],
    standalone: false
})
export class FavoriteLinksComponent implements OnInit {
  @Input() displayModalDialog = false;
  links = [];
  objects = [];
  dashboards = [];


  editLinkId = undefined;


  isLoading = true;
  page = 'links';

  constructor(private ref: ChangeDetectorRef,
              private request: SemRestRequestService,
              private router: Router,
              private isAuthorizedService: IsAuthorizedService,
              private favoritesApiService: FavoritesApiService,
              private messageService: InsparkMessageService,
              private ngxTranslateService: TranslateService,
  ) {
  }

  ngOnInit() {
    return;
  }

  /**
   * Отображает модальный диалог со списком ссылок
   */
  showDialog() {
    this.loadFavLinks();
    this.displayModalDialog = true;
    this.ref.markForCheck();
  }

  /**
   * Скрывапет модальный диалог со списком ссылок
   */
  hideDialog() {
    this.displayModalDialog = false;
    this.ref.markForCheck();
  }

  /**
   * Загружает список ссылок
   */
  loadFavLinks() {
    if (this.isAuthorizedService.isAuthorized.getValue()) {
      this.isLoading = true;
      this.favoritesApiService.getAll().subscribe((items) => {
        this.links = items.filter((val) => val.linktype !== FavoriteType.MENU);
        this.objects = items.filter((val) => val.linktype === FavoriteType.OBJECT);
        this.dashboards = items.filter((val) => val.linktype === FavoriteType.EXDASHBOARD);
        this.isLoading = false;
      });
    }
  }

  /**
   * Обрабатывает событие на удаление ссылки
   * @param $event
   */
  deleteFavLink($event) {
    this.favoritesApiService.delete($event).subscribe(() => this.loadFavLinks());
  }

  editFavLink($event) {
    this.editLinkId = $event;
  }

  closeDialog() {
    this.editLinkId = undefined;
    this.loadFavLinks();
  }

  /**
   * Обрабатывает событие на обновление данных ссылки
   * @param {FavoriteLink} fl
   */
  updateFavLink(fl: FavoriteLink) {
    this.request
      .baseUrlAppend(ApiList.Db, ApiList.User, ApiList.Profile, ApiList.Favorites)
      .updateById(fl.id, fl)
      .subscribe(() => this.loadFavLinks());

  }

  /**
   * Обрабатывае событие на переход по ссылке
   * @param url
   */
  navigateByFavLink(url) {
    this.router.navigateByUrl(url.split('#!/')[1]).then(() => this.hideDialog()).catch((e) => {
      this.messageService.error(this.ngxTranslateService.instant('Wrong Link'));
    });
  }

  activatePage(pageName) {
    this.page = pageName;
  }
}
